import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/filters/styles.scss';export default {
  "filters": "_filters_11tt9_1",
  "resetButton": "_resetButton_11tt9_17",
  "label": "_label_11tt9_25",
  "section": "_section_11tt9_32"
};